// Dependency-free storage helpers for the Machines "company switcher".
// Kept free of React/service imports so both api.ts (a non-React module) and the
// React contexts can use it without forming an import cycle.

export interface Company {
  tenantId: number;
  name: string;
}

const STORAGE_KEY = 'selectedMachineCompany';

export const getSelectedCompany = (): Company | null => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed.tenantId === 'number') return parsed as Company;
    return null;
  } catch {
    return null;
  }
};

export const storeSelectedCompany = (company: Company | null): void => {
  if (company) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(company));
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
};

export const clearSelectedCompany = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};
